<template>
    <div class='txxsc box' v-if='!isLoading'>
        <table class="list">
            <col style="width:150px"/>
            <col style="width:160px"/>
            <col style="width:160px"/>
            <col style="width:140px"/>
            <thead>
                <tr>
                    <td>是否上传投标文件</td>
                    <td v-if='scfs=="2"'>是否缴纳投标保证金</td>
                    <td>审查结果</td>
                    <td>审查意见</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <template v-if='tbdw.id'>
                        <!-- <td v-html="tbdw.sfqd=='0'?'<span class=\'red\'>否</span>':'<span class=\'success\'>是</span>'"></td> -->
                        <td v-html="tbdw.fbyjdzbs=='0'?'<span class=\'red\'>否</span>':'<span class=\'success\'>是</span>'"></td>
                        <td v-if='scfs=="2"' v-html="tbdw.sfjnbzj=='0'?'<span class=\'red\'>否</span>':'<span class=\'success\'>是</span>'"></td>
                        <td v-html="tbdw.kbsczt=='2'?'<span class=\'red\'>未通过</span>':'<span class=\'success\'>已通过</span>'"></td>
                        <td>{{tbdw.bz}}</td>
                    </template>
                    <template v-else>
                        <!-- <td></td> -->
                        <td></td>
                        <td v-if='scfs=="2"'></td>
                        <td></td>
                        <td></td>
                    </template>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
    export default {
        name:'tbyxxsc',
        props:['djlcId'],
        data(){
            return{
                tbdw:{},
                scfs:'1',
                isLoading:true
            }
        },
        methods:{
            getData(){
                let para={
                    djlcId:this.djlcId
                }
                this.$api.yxxscTbr(para).then(res=>{
                    if(res.data.meta.success){
                        if(res.data.data.tbdw.kbsczt!='0'){
                            this.tbdw=res.data.data.tbdw;
                            this.scfs=res.data.data.kbxm.scfs
                        }
                        this.isLoading=false
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                        this.isLoading=false
                    }
                }).catch(()=>{})
            },
        },
        mounted(){
            this.getData();
        }
    }
</script>    